import { render, staticRenderFns } from "./ResourceReport.vue?vue&type=template&id=bf2040a6"
import script from "./ResourceReport.vue?vue&type=script&lang=js"
export * from "./ResourceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports